import React, { useState } from "react";
import { TableBodyClass, createClient } from "../../services/Utility";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { PDFViewer, Document, Page, Text, Image, View, Line } from '@react-pdf/renderer';
import Styles from './PrintFormStyles';

export default function PrintForm(props) {
  const printDocument = () => {
    const input = document.getElementById('divToPrint');
    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        pdf.addImage(imgData, 'JPEG', 0, 0);
        pdf.save("download.pdf");
      })
      ;
  }
  return (
    <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto" >
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div className="pdf-container relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <PDFViewer style={{ height: '72vh', width: '100%' }}>
              <Document>
                <Page wrap size="A4">
                  <View fixed style={Styles.headerContainer}>
                    <Image style={Styles.headerImg} src="/images/R2CLogo.png" />
                  </View>
                  <Text style={Styles.heading}>{props.title}</Text>
                  <View style={Styles.body}>
                    {props.type == "ROPA" ?
                      <View>
                        <Text style={Styles.sectionTitle}>Data Privacy Officer / Primary Contact</Text>
                        {props.contact.map(item =>
                          <View style={Styles.field}>
                            <Text style={Styles.label}>{item.label}: </Text>
                            <Text>{item.type == "date" ? props.formState[item.name]?.slice(0, -14) : props.formState[item.name] ? props.formState[item.name] : "---"}</Text>
                          </View>
                        )}
                        <Line />
                        <Text style={Styles.sectionTitle}>Basic Details</Text>
                        {props.ropaName.map(item =>
                          <View style={Styles.textContainer}>
                            <Text>{item.type == "date" ? props.formState[item.name]?.slice(0, -14) : props.formState[item.name] ? props.formState[item.name] : "---"}</Text>
                          </View>
                        )}
                        <Line />
                        <Text style={Styles.sectionTitle}>Records of Processing Activity</Text>
                        {TableBodyClass("ropa").filter(item => item.type == "select").map(item =>
                          <View style={Styles.field}>
                            <Text style={Styles.label}>{item.label}: </Text>
                            <Text>{props.formState[item.name]?.length ? props.formState[item.name]?.map(i => i.label).join(', ') :
                              props.formState[item.name]?.label ? props.formState[item.name]?.label : "---"}</Text>
                          </View>
                        )}
                      </View>
                      :
                      <View>
                        <Text style={Styles.sectionTitle}>Details</Text>
                        {createClient(props.type).map(item =>
                            <View style={Styles.field}>
                              <Text style={Styles.label}>{item.title}: </Text>
                              <Text>{item.type == "date" ? props.formState[item.name]?.slice(0, -14) :
                                props.formState[item.name]?.label ? props.formState[item.name]?.label :
                                  props.formState[item.name]}</Text>
                            </View>
                          )}
                      </View>
                    }
                  </View>
                </Page>
              </Document>
            </PDFViewer>

            {/* <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4" id="divToPrint" >
              <div className="sm:flex sm:items-start">

                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 className="text-base font-semibold leading-6 text-gray-900" id="modal-title">{props.title}</h3>
                  <div className="mt-2">
                    {props.type == "ROPA" ?
                      <div>
                        <div className="text-base mb-2">Data Privacy Officer / Primary Contact</div>
                        <div className="grid grid-cols-1 border border-gray-300">
                          {props.contact.map(item =>
                            <div className="p-2 flex border border-gray-300">
                              <div className="w-32">{item.label}: </div>
                              <div>{item.type == "date" ? props.formState[item.name]?.slice(0, -14) : props.formState[item.name] ? props.formState[item.name] : "---"}</div>
                            </div>
                          )}
                        </div>
                        <hr
                          className="my-12 h-0.5 border-t-0 bg-neutral-100 opacity-100 dark:opacity-50" />
                        <div className="text-base mb-2">Basic Details</div>
                        <div className="grid grid-cols-1  border border-gray-300">
                          {props.ropaName.map(item =>
                            <div className="p-2 flex border border-gray-300">
                              <div className="w-32">{item.label}: </div>
                              <div>{item.type == "date" ? props.formState[item.name]?.slice(0, -14) : props.formState[item.name] ? props.formState[item.name] : "---"}</div>
                            </div>
                          )}
                        </div>
                        <hr
                          className="my-12 h-0.5 border-t-0 bg-neutral-100 opacity-100 dark:opacity-50" />
                        <div className="text-base mb-2">Records of Processing Activity</div>
                        <div className="grid grid-cols-1  border border-gray-300">
                          {TableBodyClass("ropa").filter(item => item.type == "select").map(item =>
                            <div className="p-2 flex border border-gray-300">
                              <div className="w-32">{item.label}:</div>
                              <div>{props.formState[item.name]?.label ? props.formState[item.name]?.label : "---"}</div>
                            </div>
                          )}
                        </div>

                      </div>
                      :
                      <div>
                        <div className="text-base mb-2">Details</div>
                        <div className="grid grid-cols-1 border border-gray-300">
                          {createClient(props.type).map(item =>
                            <div className="p-2 flex border border-gray-300" style={{ flexDirection: 'column', justifyContent: 'flex-start' }}>
                              <div className="w-32" style={{ fontWeight: 'bold' }}>{item.title}</div>
                              <div>{item.type == "date" ? props.formState[item.name]?.slice(0, -14) :
                                props.formState[item.name]?.label ? props.formState[item.name]?.label :
                                  props.formState[item.name]}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div> */}
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button type="button" className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                onClick={() => printDocument()}>Print</button>
              <button type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                onClick={() => props.closeModal()}>Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
